import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { convertMinutesToTime } from '@repo/ui/src/functions/recipe-functions';

import { useMemo } from 'react';

export const useCreateRecipeTime = (minutes: number) => {
  const { t } = useTranslation();
  const time = convertMinutesToTime(minutes);

  return useMemo(() => {
    const result = [];

    if (time.days > 0) {
      const cookDays = {
        label: t('unitsOfTime.daysLabel', undefined, { default: 'Days' }),
        value: time.days,
      };
      result.push(cookDays);
    }
    if (time.hours > 0) {
      const cookHours = {
        label: t('unitsOfTime.hoursLabel', undefined, { default: 'Hrs' }),
        value: time.hours,
      };
      result.push(cookHours);
    }
    if (time.min > 0) {
      const cookMinutes = {
        label: t('unitsOfTime.minutesLabel', undefined, { default: 'Min' }),
        value: time.min,
      };
      result.push(cookMinutes);
    }

    return result;
  }, [time, t]);
};
